import { render } from "./OvDocumentsModal.vue?vue&type=template&id=71564f8a&scoped=true"
import script from "./OvDocumentsModal.vue?vue&type=script&lang=js"
export * from "./OvDocumentsModal.vue?vue&type=script&lang=js"

import "./OvDocumentsModal.vue?vue&type=style&index=0&id=71564f8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71564f8a"]])

export default __exports__